import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "route-query"
    }}>{`route query`}</h1>
    <p>{`A merchant can reconfigure (rewrite) the URL to any product, category, or CMS page. When the rewrite goes into effect, any links that point to the previous URL are redirected to the new address.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`route`}</inlineCode>{` query returns the canonical URL for a specified product, category, or CMS page. An external app can render a page by a URL without any prior knowledge about the landing page. To query for product and category pages, the `}<inlineCode parentName="p">{`url`}</inlineCode>{` value must contain the URL key and suffix. For CMS page queries, the `}<inlineCode parentName="p">{`url`}</inlineCode>{` value must contain the URL key only.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <p><inlineCode parentName="p">{`{route(url: String!): RoutableInterface}`}</inlineCode></p>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#query-route"
      }}><inlineCode parentName="a">{`route`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this query.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following query returns information about the product with the URL key of `}<inlineCode parentName="p">{`joust-duffle-bag.html`}</inlineCode>{`. The response indicates the URL key has been permanently redirected to `}<inlineCode parentName="p">{`new-joust-duffle-bag.html`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`{
  route(url: "joust-duffle-bag.html") {
    __typename
    relative_url
    redirect_code
    type
    ... on SimpleProduct {
      sku
      url_key
      uid
      url_rewrites {
        url
        parameters {
          name
          value
        }
      }
      relative_url
      redirect_code
      type
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "route": {
      "__typename": "SimpleProduct",
      "relative_url": "new-joust-duffle-bag.html",
      "redirect_code": 301,
      "type": "PRODUCT",
      "sku": "24-MB01",
      "url_key": "new-joust-duffle-bag",
      "uid": "MQ==",
      "url_rewrites": [
        {
          "url": "new-joust-duffle-bag.html",
          "parameters": [
            {
              "name": "id",
              "value": "1"
            }
          ]
        },
        {
          "url": "gear/new-joust-duffle-bag.html",
          "parameters": [
            {
              "name": "id",
              "value": "1"
            },
            {
              "name": "category",
              "value": "3"
            }
          ]
        },
        {
          "url": "gear/bags/new-joust-duffle-bag.html",
          "parameters": [
            {
              "name": "id",
              "value": "1"
            },
            {
              "name": "category",
              "value": "4"
            }
          ]
        }
      ]
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "related-topics"
    }}>{`Related topics`}</h2>
    <p><a parentName="p" {...{
        "href": "../interfaces/routable.md"
      }}>{`RoutableInterface`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      